<template>
	<div class="w-full mt-6">
		<div class="relative mb-5">
			<div class="absolute inset-0 flex items-center" aria-hidden="true">
				<div class="w-full border-t border-gray-300" />
			</div>
			<div class="relative flex justify-center">
				<span class="bg-white px-2 font-semibold text-blue-700">Linha Temporal da Proposta</span>
			</div>
		</div>
		<div class="max-h-[400px] overflow-y-auto px-4 w-full mt-6">
			<ol class="relative border-s border-gray-200 dark:border-gray-700">
				<li
					v-for="item in timeline"
					:key="item.id"
					class="mb-10 ms-4"
				>
					<div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
					<time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
						{{ new Date(item.created_at).toLocaleString() }}
					</time>
					<h3 class="text-lg font-semibold text-gray-900 dark:text-white">
						{{ item.titulo }}
					</h3>
					<p class="mb-1 text-sm text-gray-500 dark:text-gray-400 italic">
						Autor: {{ item.autor_email }}
					</p>
					<p class="text-base font-normal text-gray-700 dark:text-gray-300">
						<!-- Se for observação, mostra o conteúdo; senão, a descrição padrão -->
						{{ item.tipo === 'observacao adicionada' ? item.dados_extras?.conteudo : item.descricao }}
					</p>
			</li>
			</ol>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'PropostaTimeline',
		async created(){},
		props: {
			timeline:{
				type:Array,
				required:true
			}
		},  
		watch: {
			
		}, 
		data() {
			return {
				
			}
		},
		methods: {
			
		},
		components:{
		},
	}
</script>